import {
    ROUTES_REPORTS,
    ROUTES_REPORTS_COMPARISON,
    ROUTES_REPORTS_GMT,
    ROUTES_REPORTS_MORNING_MONITORING,
    ROUTES_REPORTS_MM_DAILY,
    ROUTES_REPORTS_MM_INJURY_ILLNESS,
    ROUTES_REPORTS_MM_TRAINING_QUALITY,
    ROUTES_REPORTS_RPE,
    ROUTES_REPORTS_ATTENDANCE,
    ROUTES_REPORTS_TRAINING_SUMMARY,
    ROUTES_REPORTS_TEAM_TRAINING_SUMMARY,
    ROUTES_REPORTS_TEAM_ERGO
} from '@/constants/routes';

import { REPORTS_ROUTES_DRV } from './reports-drv';
import { REPORTS_ROUTES_AUS } from './reports-aus';

const ReportsPage = () => import(/*webpackChunkName: 'reports'*/ '@/views/reports/ReportsMain.vue');
const ReportsMorningMonitoring = () =>
    import(/*webpackChunkName: 'reports'*/ '@/views/reports/ReportsMorningMonitoring.vue');
const ReportsGMT = () => import(/*webpackChunkName: 'reports'*/ '@/components/reports/GMT/Gmt.vue');
const ReportsRpe = () => import(/*webpackChunkName: 'reports'*/ '@/components/reports/RPE/Rpe.vue');
const ReportsMorningMonitoringDaily = () =>
    import(/*webpackChunkName: 'reports'*/ '@/components/reports/morning-monitoring/MorningMonitoringDaily.vue');
const ReportsMorningMonitoringInjuryIllness = () =>
    import(
        /*webpackChunkName: 'reports'*/ '@/components/reports/morning-monitoring/MorningMonitoringInjuryIllness.vue'
    );
const ReportsMorningMonitoringTrainingQuality = () =>
    import(
        /*webpackChunkName: 'reports'*/ '@/components/reports/morning-monitoring/MorningMonitoringTrainingQuality.vue'
    );
const ReportsAttendance = () =>
    import(/*webpackChunkName: 'reports'*/ '@/components/reports/attendance/Attendance.vue');
const ReportsTrainingSummary = () =>
    import(/*webpackChunkName: 'reports'*/ '@/components/reports/training-summary/TrainingSummary.vue');
const ReportsTeamTrainingSummary = () =>
    import(/*webpackChunkName: 'reports'*/ '@/components/reports/team-training-summary/TeamTrainingSummary.vue');
const ReportsTeamErgo = () =>
    import(/*webpackChunkName: 'reports-additional'*/ '@/components/reports/team-ergo/TeamErgo.vue');

const ReportsComparison = () =>
    import(/*webpackChunkName: 'profile-reports'*/ '@/components/reports/individual/comparison/ReportsComparison');

import store from '@/store';
import { guardRoute } from '@/router';

export default {
    name: ROUTES_REPORTS,
    component: ReportsPage,
    meta: {
        requiresFocuses: true
    },
    path: '/reports',
    redirect: { name: ROUTES_REPORTS_MORNING_MONITORING },
    children: [
        {
            name: ROUTES_REPORTS_GMT,
            path: 'gmt',
            beforeEnter: guardRouteGmt,
            component: ReportsGMT
        },
        {
            name: ROUTES_REPORTS_MORNING_MONITORING,
            path: 'morning-monitoring',
            redirect: {
                name: ROUTES_REPORTS_MM_DAILY
            },
            component: ReportsMorningMonitoring,
            children: [
                {
                    name: ROUTES_REPORTS_MM_DAILY,
                    path: 'daily',
                    beforeEnter: guardRouteMorningMonitoring,
                    component: ReportsMorningMonitoringDaily
                },
                {
                    name: ROUTES_REPORTS_MM_INJURY_ILLNESS,
                    path: 'injury-illness',
                    beforeEnter: guardRouteMorningMonitoring,
                    component: ReportsMorningMonitoringInjuryIllness
                },
                {
                    name: ROUTES_REPORTS_MM_TRAINING_QUALITY,
                    path: 'training-quality',
                    beforeEnter: guardRouteMorningMonitoring,
                    component: ReportsMorningMonitoringTrainingQuality
                }
            ]
        },
        {
            name: ROUTES_REPORTS_RPE,
            path: 'rpe',
            beforeEnter: guardRouteRpe,
            component: ReportsRpe
        },
        {
            name: ROUTES_REPORTS_ATTENDANCE,
            path: 'attendance',
            beforeEnter: guardRouteAttendance,
            component: ReportsAttendance
        },
        {
            name: ROUTES_REPORTS_TRAINING_SUMMARY,
            path: 'training-summary',
            beforeEnter: guardRouteTrainingSummary,
            component: ReportsTrainingSummary
        },
        {
            name: ROUTES_REPORTS_TEAM_TRAINING_SUMMARY,
            path: 'team-training-summary',
            beforeEnter: guardRouteTrainingSummary,
            component: ReportsTeamTrainingSummary
        },
        {
            name: ROUTES_REPORTS_TEAM_ERGO,
            path: 'team-ergo',
            beforeEnter: guardRouteErgo,
            component: ReportsTeamErgo
        },
        {
            name: ROUTES_REPORTS_COMPARISON,
            path: 'comparison/:id',
            beforeEnter: guardRouteComparison,
            component: ReportsComparison
        },
        ...REPORTS_ROUTES_DRV,
        ...REPORTS_ROUTES_AUS
    ]
};

function guardRouteErgo(to, from, next) {
    const notInFeatureSet = !store.getters['clubPermissions/canViewFeatureAdditionalReports'];
    const unauthorized =
        !store.getters.isCurrentUserAthleteOfSelectedClub &&
        !store.getters['userPermissions/canViewAllMembersErgoProgressReport'];
    guardRoute(next, unauthorized, notInFeatureSet);
}

function guardRouteGmt(to, from, next) {
    const notInFeatureSet = !store.getters['clubPermissions/canViewFeatureGmt'];
    const unauthorized =
        !store.getters.isCurrentUserAthleteOfSelectedClub &&
        !store.getters['userPermissions/canViewAllMembersGmtReport'];
    guardRoute(next, unauthorized, notInFeatureSet);
}

function guardRouteRpe(to, from, next) {
    const notInFeatureSet = !store.getters['clubPermissions/canViewFeatureRpe'];
    const unauthorized =
        !store.getters.isCurrentUserAthleteOfSelectedClub &&
        !store.getters['userPermissions/canViewAllMembersRpeReport'];
    guardRoute(next, unauthorized, notInFeatureSet);
}

function guardRouteAttendance(to, from, next) {
    const unauthorized =
        !store.getters.isCurrentUserAthleteOfSelectedClub &&
        !store.getters['userPermissions/canViewAllMembersAttendanceReport'];
    guardRoute(next, unauthorized);
}

function guardRouteTrainingSummary(to, from, next) {
    const unauthorized =
        !store.getters.isCurrentUserAthleteOfSelectedClub &&
        !store.getters['userPermissions/canViewAllMembersTrainingSummaryReport'];
    guardRoute(next, unauthorized);
}

function guardRouteMorningMonitoring(to, from, next) {
    const notInFeatureSet = !store.getters['clubPermissions/canViewFeatureMorningMonitoring'];
    const unauthorized =
        !store.getters.isCurrentUserAthleteOfSelectedClub &&
        !store.getters['userPermissions/canViewAllMembersMorningMonitoringReport'];
    guardRoute(next, unauthorized, notInFeatureSet);
}

function guardRouteComparison(to, from, next) {
    const notInFeatureSet = !store.getters['clubPermissions/canViewFeatureComparisonReport'];
    guardRoute(next, false, notInFeatureSet);
}
